import React, { FC } from "react";
import SectionGridHasMap from "./SectionGridHasMap";
import { Helmet } from "react-helmet";
import { useLocale } from "i18n/locale";
import { useAppContext } from "AppContext";

// Paris first, per the client's design ("Paris | Brussels").
const CITIES = [
  { id: "Paris", labelKey: "common.paris" },
  { id: "Brussels", labelKey: "common.brussels" },
] as const;

export interface ListingStayMapPageProps {
  className?: string;
}

const ListingStayMapPage: FC<ListingStayMapPageProps> = ({
  className = "",
}) => {
  const { t } = useLocale();
  const { filterState, updateFilterState } = useAppContext();

  return (
    <div
      className={`nc-ListingStayMapPage relative bg-white ${className}`}
      style={{ marginBottom: 60 }}
      data-nc-id="ListingStayMapPage"
    >
      <Helmet>
        <title>Europea || Booking</title>
      </Helmet>

      {/* Page tagline */}
      <div className="px-4 sm:px-6 lg:px-[40px] mt-[14px]">
        <div className="flex flex-col">
          <p
            className="text-[11px] uppercase tracking-[2.2px] leading-[24px] text-[#B88333]"
            style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600 }}
          >
            {t("home.tagline")}
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center gap-[4px] sm:gap-[16px]">
            <p
              className="flex-1 text-[18px] sm:text-[20px] tracking-[0.4px] text-[#01152E]"
              style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
            >
              {t("home.heading")}
            </p>
            {/* City selector — writes the same filterState.location the header's
                location dropdown does, so both stay in sync and the listing
                refetches. null (no city picked) shows Paris as active, matching
                the map, which also falls back to Paris. */}
            <div
              role="radiogroup"
              aria-label={t("common.location")}
              className="flex items-center self-start sm:self-auto rounded-[100px] border border-[#E6D5BA] bg-white flex-shrink-0 overflow-hidden"
              style={{ boxShadow: "0px 1px 4px rgba(0,0,0,0.12)" }}
            >
              {CITIES.map((city) => {
                const active = (filterState?.location || "Paris") === city.id;
                return (
                  <button
                    key={city.id}
                    type="button"
                    role="radio"
                    aria-checked={active}
                    onClick={() => {
                      if (filterState?.location !== city.id) {
                        updateFilterState("location", city.id);
                      }
                    }}
                    className={`min-w-[70px] h-[26px] px-[14px] rounded-[100px] border-0 text-[10px] leading-[26px] whitespace-nowrap cursor-pointer transition-colors ${
                      active
                        ? "bg-[#BE8F58] text-white"
                        : "bg-transparent text-[#01152E] hover:text-[#BE8F58]"
                    }`}
                    style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600 }}
                  >
                    {t(city.labelKey)}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <SectionGridHasMap />
    </div>
  );
};

export default ListingStayMapPage;
